// styles
import styles from './text-image.module.scss';

// types
import type { HeadlineProps } from '.';
import { Formats } from 'components/ContentElementsGdds/headline/headlines.types';

// components
import { Headline as GlobalHeadline, FontWeights } from 'components/ContentElements/Headline';
import { Headline as GDDSHeadline } from 'components/ContentElementsGdds/headline/headline';

// utils
import { getSubtitleContent, getTitleContent, getUseSubline } from '.';
import { useGroup } from 'utils/hooks/use-group';

export function Headline({
  title,
  subtitle,
  subline,
  format,
  emphasize,
  aboveHeadline,
  className,
  childOf,
  isChild = false,
  sublineNoHTag = false,
}: Readonly<HeadlineProps>) {
  const isGroup = useGroup();

  let titleContent = getTitleContent(!isGroup, title, subline, aboveHeadline);
  let subTitleContent = getSubtitleContent(!isGroup, subtitle, aboveHeadline);
  const isSubline = getUseSubline(!isGroup, aboveHeadline);

  if (isGroup) {
    return (
      <GlobalHeadline
        title={titleContent}
        subtitle={subTitleContent}
        titleFontWeight={emphasize === 'title' ? FontWeights.bold : FontWeights.regular}
        subtitleFontWeight={emphasize === 'subtitle' ? FontWeights.bold : FontWeights.regular}
        format={format ? Formats[format] : Formats.h2}
        className={styles.headline}
        titlePreviewId={'#st_title'}
        subtitlePreviewId="#st_subtitle"
      />
    );
  }

  const isChildOfAccordionOrTab = isChild && childOf && ['tab', 'accordion'].includes(childOf);
  // Check if the subline is outputted, else normal headline.
  const formatNormal = isSubline ? (sublineNoHTag ? Formats.div : Formats.h3) : Formats.h2;
  const formatIsChild = isSubline ? (sublineNoHTag ? Formats.div : Formats.h5) : Formats.h4;

  return (
    <GDDSHeadline
      title={titleContent}
      subtitle={subTitleContent}
      tag={isChildOfAccordionOrTab ? formatIsChild : formatNormal}
      variant={format ? Formats[format] : formatNormal}
      className={className}
      titlePreviewId={'#st_title'}
      subtitlePreviewId="#st_subtitle"
    />
  );
}
